module.exports = __webpack_public_path__ + "79ec428a2510436c6b6730b18e84d443.pdf";